import { useTranslation } from "react-i18next";
import "./ScanGuidance.scss";
import { HairDownIcon } from "../../icons/HairDownIcon";
import { useUID } from "../../../context/UIDContext";
import { useAmplitude } from "../../../context/AmplitudeContext";

export const ScanGuidance = ({ onContinue }) => {
  const { t } = useTranslation("scanGuidancePage");
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  return (
    <div className="scan-guidance-overlay">
      <div className="scan-guidance-content">
        <HairDownIcon className={"hair-icon"} />
        <p className="scan-guidance-text">{t("scan-guidance-text")}</p>
        <button
          onClick={() => {
            trackEvent("webapp_user_press_scan_pop", uid);
            onContinue();
          }}
          className="take-photo-button"
        >
          {t("scan-guidance-start-button")}
        </button>
      </div>
    </div>
  );
};
